// delta5-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{arg1}: falhou": "%{arg1}: falló",
    "A URL já é o destino e o segredo — não precisa de lista de destinatários.": "La URL ya es el destino y el secreto — no necesita lista de destinatarios.",
    "Adicionar destinatário": "Agregar destinatario",
    "Adicione ao menos um destinatário para ativar os envios.": "Agregue al menos un destinatario para activar los envíos.",
    "Alertas de saldo negativo": "Alertas de saldo negativo",
    "Configure quem recebe o aviso das ocorrências de saldo negativo — por e-mail ou num canal do Discord — e desligue os envios a qualquer momento.": "Configure quién recibe el aviso de las ocurrencias de saldo negativo — por e-mail o en un canal de Discord — y desactive los envíos en cualquier momento.",
    "Desligado, as ocorrências continuam sendo registradas e aparecem neste relatório — só não sai mensagem.": "Apagado, las ocurrencias siguen registrándose y aparecen en este reporte — solo no se envía ningún mensaje.",
    "Destinatários": "Destinatarios",
    "Discord": "Discord",
    "E-mail inválido": "E-mail inválido",
    "Enviado no webhook do Discord": "Enviado en el webhook de Discord",
    "Espera após falha no envio": "Espera después de una falla en el envío",
    "Ignorar antes de": "Ignorar antes de",
    "Informe a URL do webhook do Discord para ativar os envios.": "Ingrese la URL del webhook de Discord para activar los envíos.",
    "Mascarar o CPF na mensagem": "Enmascarar el CPF en el mensaje",
    "Nenhum destinatário — nenhum alerta será enviado.": "Ningún destinatario — no se enviará ninguna alerta.",
    "Não foi possível carregar a configuração de alertas": "No se pudo cargar la configuración de alertas",
    "Ocorrências anteriores não geram aviso": "Las ocurrencias anteriores no generan aviso",
    "Por onde o alerta sai. Um canal por vez.": "Por dónde sale la alerta. Un canal a la vez.",
    "Reaviso (min)": "Reaviso (min)",
    "Remover destinatário": "Quitar destinatario",
    "Retentativa (min)": "Reintento (min)",
    "Saldo máximo": "Saldo máximo",
    "Silêncio por cliente após avisar": "Silencio por cliente después de avisar",
    "Só alerta saldo até este valor. Vazio = qualquer negativo.": "Solo alerta saldo hasta este valor. Vacío = cualquier negativo.",
    "Um canal do Discord tem audiência mais larga e histórico pesquisável que a lista de e-mail. Quem precisa do CPF inteiro abre este relatório.": "Un canal de Discord tiene una audiencia más amplia y un historial consultable que la lista de e-mail. Quien necesite el CPF completo abre este reporte.",
    "Webhook do Discord": "Webhook de Discord",
    "alguem@pontuax.com.br": "alguien@pontuax.com.br",
    "✉️ E-mail": "✉️ E-mail",
    "💬 Discord": "💬 Discord",
};

export default catalogo;
